module.exports = __webpack_public_path__ + "static/FS-Vent-3-1-bd294832b53be26fe7558bc5fbcce59a.png";